import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledCartAmountSelector = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  .amount-selector.productView {
    height: 62px;
  }

  .amount-selector {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
    border: 1px solid ${(props) => props.theme.mediumGrey};
    border-radius: 20px;
    cursor: default;
    color: ${(props) => props.theme.black};

    .unit-unit-type {
      display: flex;
      gap: 5px;
      align-items: center;

      .ant-form-item{
        margin-bottom: 0;
        .ant-form-item-control-input {
          min-height: unset;
          height: 31px;
          

          .ant-input-number-outlined {
            border: none;
            box-shadow: none;
            width: -webkit-fill-available;

            input{
              text-align: center;
              height: 24px;
              padding: 0;
              width: 52px;
            }
          }
        }
      }
      @media only screen and (max-width: ${breakpoints.md}px) {
        font-size: 1rem;
      }
    }

    button {
      background: none;
      border: none;
      padding: 6px 13px 6px 13px;
      font-weight: 500;
      font-size: 15px;
      cursor: pointer;

      &:hover {
        font-weight: 700;
      }
    }
  }

  .ant-tooltip-inner {
    padding: 12px;
    width: 400px;
    border-radius: 8px;
    font-size: 12px;

    .tooltip-availability,
    .tooltip-reservations {
      font-weight: 600;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .amount-selector {
      button {
        font-size: 1rem !important;
      }
    }
  }
`;
